import "clsx";
function _page($$renderer) {
  $$renderer.push(`<div class="stack center readable" style="padding: var(--vs-xl) var(--hpad); place-items: start; place-self: center;"><h5 class="pblue">Neurologie</h5> <p>Schlaganfall, Schädelhirntrauma, Multiple Sklerose, Morbus Parkinson,
          Amyotrophe Lateralsklerose und weitere Krankheiten des zentralen
          Nervensystems</p> <h5 class="pblue">Geriatrie</h5> <p>Ältere Menschen mit Funktionseinschränkungen, Mehrfacherkrankungen,
          nach einer Operation oder für die Wiedereingleiderung zu Hause</p></div>`);
}
export {
  _page as default
};
